<ng-container
  *ngIf="{
    draft: draft$ | async,
    isNew: isNewWorkspace$ | async,
    caseTypes: caseTypes$ | async,
    caseTypesLoading: caseTypesLoading$ | async,
    noCaseTypes: noCaseTypes$ | async,
    selectedCaseTypeId: selectedCaseTypeId$ | async,
    searchTerm: searchTerm$ | async,
    previousCaseTypeTokens: previousCaseTypeTokens$ | async,
    nextCaseTypeToken: nextCaseTypeToken$ | async,
    totalCount: totalCount$ | async,
    pageSize: pageSize$ | async,
    counting: counting$ | async,
    environments: environments$ | async,
    draftEnvironment: draftEnvironment$ | async,
    canSave: canSave$ | async,
    saving: saving$ | async,
    loading: loading$ | async
  } as state"
>
  <div class="editor-wrapper">
    <ts-loading-overlay
      *ngIf="state.loading || state.saving"
      [message]="state.saving ? 'dialog.saving_workspace' : 'info.loading_data'"
    ></ts-loading-overlay>
    <div class="card padded">
    <div class="card-body">
      <h2>
        {{ (state.isNew ? 'button.new_workspace' : 'title.edit_workspace') | translate }}
      </h2>

      <mat-form-field style="width: 100%">
        <input
          matInput
          autofocus
          placeholder="{{ 'input.workspace_name' | translate | uppercase }}"
          required
          type="text"
          [value]="state.draft?.name ?? ''"
          (input)="onNameChange($event.target.value)"
          data-cy="workspace-name"
        />
      </mat-form-field>

      <div class="form-control-group" id="case-type-selection">
        <label class="form-control-label">{{ 'core.case_type' | translate | uppercase }}</label>
        <ts-paginated-search-header
          class="align-items-center pt-1 pb-0"
          [searchValue]="state.searchTerm"
          (searchChanged)="searchTermChanged($event)"
          [previousTokens]="state.previousCaseTypeTokens"
          [lastItem]="state.nextCaseTypeToken"
          [length]="state.totalCount"
          [pageSize]="state.pageSize"
          [disabled]="state.caseTypesLoading"
          (pageChange)="handlePageEvent($event)"
          [counting]="state.counting"
        ></ts-paginated-search-header>
        <ts-case-type-selection
          [items]="state.caseTypes"
          [noCaseTypes]="state.noCaseTypes"
          [selectedCaseTypeId]="state.selectedCaseTypeId"
          (caseTypeSelected)="onCaseTypeSelected($event)"
        ></ts-case-type-selection>
      </div>

      <mat-form-field class="full-width">
        <mat-label> {{ 'label.environment' | translate }} ({{ 'core.optional' | translate }}) </mat-label>
        <mat-select [value]="state.draftEnvironment" (selectionChange)="onEnvironmentChange($event.value)">
          <mat-option>None (default)</mat-option>
          <mat-option *ngFor="let item of state.environments" [value]="item.environment" [disabled]="!item.enabled">
            {{ item.environment }}
            <span *ngIf="!item.enabled" class="text-gray ms-2">
              Not included by your organization's current license
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="card-footer no-hr card-actions">
      <button id="cancel" type="button" class="btn btn-outline-primary card-actions__action" (click)="onCancel()">
        <i class="ri-close-fill"></i>
        {{ 'button.cancel' | translate }}
      </button>
      <button
        id="save"
        data-cy="save-workspace"
        class="btn btn-primary card-actions__action"
        type="button"
        (click)="onSave()"
        [disabled]="!state.canSave"
      >
        <i class="ri-save-line"></i>
        {{ 'button.save' | translate }}
      </button>
    </div>
    </div>
  </div>
</ng-container>
